import React from 'react';

import { CancelButton } from '../Button';
import { Box, Grid, Modal } from '@mui/material';
import { Heading, style, RedButton } from './Elements';
import { GreenButton, PlanName, Text } from '../../pages/Settings/Elements';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { responseMessages } from '../../data';
// import { Text } from '../../pages/Elements';

const MakeItPrimary = ({ data, open, MakeItPrimary, setOpen }) => {
  const { userInfo, isAuth } = useSelector((state) => state.auth);
  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: 'unset' }}
      >
        <Box
          sx={{
            ...style,
            width: 550,
            height: 'max-content',
            pb: 4,
            pt: 2,
            px: 2,
            alignItems: 'flex-start',
          }}
        >
          <Box className="centerDiv">
            <Text>
              <PlanName sx={{ textAlign: 'center', fontSize: '1.375rem' }}>
                {responseMessages.primaryCardAlert}
              </PlanName>
            </Text>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 2 }}>
              <GreenButton
                sx={{ mr: 2 }}
                onClick={() => MakeItPrimary(data)}
                type="submit"
                variant="contained"
                disableripple
              >
                Yes
              </GreenButton>
              <CancelButton
                type="submit"
                onClick={() => setOpen(false)}
                variant="contained"
                disableripple
              >
                No, keep it
              </CancelButton>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default MakeItPrimary;
